import React from "react";

export const UserContext = React.createContext({
  isAuthenticated: false,
  isAuthenticating: true,
  setAuthenticated: () => {},
  handleLogout: () => {},
  userId: null,
  identityId: null,
  setUserId: () => {},
  setIdentityId: () => {}
});

const withUser = Component => {
  return function ThemedComponent(props) {
    return (
      <UserContext.Consumer>
        {user => <Component {...props} user={user} />}
      </UserContext.Consumer>
    );
  };
};

export default withUser;



// WEBPACK FOOTER //
// ./src/components/withUser.js